export class DtcResults {
	public results: [];
	public monthAmount : number;

	constructor(o?: any) {
		Object.assign(this, o);
	}
}

